import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { EthereumClient, w3mConnectors, w3mProvider } from '@web3modal/ethereum'
import { Web3Modal } from '@web3modal/react'
import { configureChains, createConfig, WagmiConfig } from 'wagmi'
import { sepolia } from 'wagmi/chains'
import { CoinbaseWalletConnector } from '@wagmi/core/connectors/coinbaseWallet'
import { InjectedConnector } from "@wagmi/core";

//InjectedConnector
//import { injected, walletConnect, coinbaseWallet } from 'wagmi/connectors'

const chains = [sepolia]
const projectId = '1ee662092220d9e279a243cd7270bbae'

const coinbaseWallet = new CoinbaseWalletConnector({
  chains,
  options: {
    appName: "Your App Name",
    darkMode: true,
    // jsonRpcUrl: process.env.REACT_APP_JSON_RPC_URL || "https://mainnet.infura.io/v3/your-infura-project-id",
    qrCode: false,
    // trustedResources: ["https://yourdomain.com"],
    // walletLink: sdk,
  },
});


const inject = new InjectedConnector({
  chains,
  options: {
    appName: "Your App Name",
    darkMode: true,
    // jsonRpcUrl: process.env.REACT_APP_JSON_RPC_URL || "https://mainnet.infura.io/v3/your-infura-project-id",
    qrCode: false,
    // trustedResources: ["https://yourdomain.com"],
    // walletLink: sdk,
    autoConnect: true
  },
})

const { publicClient } = configureChains(chains, [w3mProvider({ projectId })])
const wagmiConfig = createConfig({
  autoConnect: true,
  connectors: w3mConnectors({ projectId, chains }),
  publicClient,
  inject,
  coinbaseWallet

})



const ethereumClient = new EthereumClient(wagmiConfig, chains)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <WagmiConfig config={wagmiConfig}>
      <App />
    </WagmiConfig>
    <Web3Modal projectId={projectId} ethereumClient={ethereumClient}>hrgdhguih</Web3Modal>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
